import { connect } from 'react-redux'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { openComparisonAccordion } from '../../../actions/comparisonActions'
import { listBenefits } from '../../../apiCalls'

import { isMobile } from '../../../utils';
import dataLayer from '../../../utils/dataLayer';


class Accordion extends Component {
    constructor(props) {
        super(props);

        const benefits = props.benefits.map(
            list => {
                if (list === undefined) {
                    return 0;
                }
                return list.filter(benefit => parseInt(benefit.code, 0) === parseInt(props.benefitCode, 0))[0]
            }

        )

        this.state = {
            benefits: benefits.reverse()
        }

        this.openDescription = this.openDescription.bind(this);
    }

    openDescription() {
        this.props.openComparisonAccordion(this.props.benefitCode)
        if (!this.props.opened) {
            dataLayer.genericEvent('sg_event', 'sp_comparacao', 'click_botao', '+detalhes')
        }
    }
    render() {
        const containerClass = `row-plano flex ${(this.props.opened ? 'active' : '')}`

        
        return (
            <div className={`row-acc ${this.props.last}`} >

                <div
                    className={containerClass}
                    onClick={this.openDescription}>

                    <div className="col-plano desc accordion-compare">
                        <span className="sigla">{this.props.name}</span>
                    </div>

                    { (!isMobile()) &&

                        [
                            <div key={3} className="col-plano">
                                <span>
                                    {
                                        (this.state.benefits[3] &&
                                            this.state.benefits[3].coverage) ||
                                                <span><div className="nao" />-</span>
                                    }
                                </span>
                            </div>,
                            <div key={2} className="col-plano">
                                <span>
                                    {
                                        (this.state.benefits[2] &&
                                            this.state.benefits[2].coverage) ||
                                                <span><div className="nao" />-</span>
                                    }
                                </span>
                            </div>
                        ]

                    }
                    <div key={1} className="col-plano">
                        <span>
                            {
                                (this.state.benefits[1] &&
                                    this.state.benefits[1].coverage) ||
                                        <span><div className="nao" />-</span>
                            }
                        </span>
                    </div>
                    <div key={0} className="col-plano">
                        <span>
                            {
                                (this.state.benefits[0] &&
                                    this.state.benefits[0].coverage) ||
                                        <span><div className="nao" />-</span>
                            }
                        </span>
                    </div>

                    <div className={(this.props.opened) ? 'more-icon open comparation' : 'more-icon comparation'}>
                        <span />
                        <span />
                    </div>
                </div>

                <div className="acc-panel-compare">
                    <hr className={this.props.position % 2 === 0 ? 'line-separator even-color' : 'line-separator odd-color'} />
                    <p>
                        {this.props.content}
                    </p>
                    <button
                        className="fechar-panel"
                        onClick={this.openDescription} />
                </div>

            </div>
        )
    }
}

class AccordionGroup extends Component {
    render() {
        let lastSize = 0
        let longestItem = 0
        this.props.benefits.forEach(
            (item, i) => {
                if (item !== undefined && item.length > lastSize) {
                    lastSize = item.length
                    longestItem = i;
                }
            })

        return (
            <div className="item-lista">
                <h3>{this.props.title}</h3>
                {
                    this.props.benefits[longestItem].map(
                        (benefit, i) => {
                            let content = this.props.benefits_list.filter((b) => (b.code === benefit.code));
                            content = content.length >= 1 ? content[0].long_description : '';
                            return (<Accordion
                                name={benefit.name}
                                key={benefit.name}
                                benefits={this.props.benefits}
                                benefitIterator={i}
                                benefitCode={benefit.code}
                                content={content}
                                opened={this.props.openedBenefitCode === benefit.code}
                                longestItem={longestItem}
                                position={i}
                                openComparisonAccordion={this.props.openComparisonAccordion} 
                                last={i === this.props.benefits[longestItem].length - 1 ? 'last' : ''} />
                            )
                        }
                    )
                }
                <div className="separador" />
            </div>
        )
    }
}

export class AccordionGroupSet extends Component {
    constructor(props) {
        super(props);
        listBenefits();
    }

    render() {
        if (!this.props.comparisonPlansInfo.length)
            return null;

        const accordionContainers = [];

        const benefits = this.props.comparisonPlansInfo.map(
            plan => (plan.benefits)
        );

        const categories = Object.keys(benefits[0]);

        categories.forEach(
            category => {
                const benefitPerCat = []

                benefits.forEach(
                    benefit => benefitPerCat.push(benefit[category])
                )
                accordionContainers.push(
                    <AccordionGroup
                        title={category}
                        key={category}
                        benefits={benefitPerCat}
                        benefits_list={this.props.benefits_list}
                        openedBenefitCode={this.props.openedBenefitCode}
                        openComparisonAccordion={this.props.openComparisonAccordion} />
                )
            }
        )

        return (
            <section className="area-lista-comparacao">
                <div className="component">
                    <div className="lista-comparacao">
                        { accordionContainers }
                    </div>
                </div>
            </section>

        )
    }
}

export default withRouter(
    connect(
        state => ({
            comparisonPlansInfo: state.comparison.comparisonPlansInfo,
            benefits_list: state.purchase.benefits_list,
            openedBenefitCode: state.comparison.openedBenefitCode
        }),
        {
            openComparisonAccordion,
        }
    )(AccordionGroupSet)
)



// WEBPACK FOOTER //
// ./src/components/comparison/accordion/Accordion.jsx